import * as React from "react";
import { forwardRef } from "react";
const SvgPingIdentity = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#d93954", rx: 4 }), /* @__PURE__ */ React.createElement("text", { x: 12, y: 16, fill: "#fff", fontFamily: "Arial, sans-serif", fontSize: 8, fontWeight: "bold", textAnchor: "middle" }, "PING"));
const ForwardRef = forwardRef(SvgPingIdentity);
export default ForwardRef;
